import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { withParentSize } from '@visx/responsive';
import TableView from './TableView';

const styles = () => ({
  root: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
});

const AllocationsTabTemplate = withParentSize(
  ({
    className,
    classes,
    parentHeight,
  }) => {
    return (
      <Box
        className={classNames(classes.root, className)}
      >
        <TableView
          height={parentHeight}
        />
      </Box>
    );
  },
);

AllocationsTabTemplate.defaultProps = {
  className: '',
};

AllocationsTabTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AllocationsTabTemplate);
